import AccountLayout from "../../layouts/account/accountLayout";
import HomeLayout from "../../layouts/home/homeLayout";
import { RouteItemConfig } from "../models";
import { AccountRoutes } from "../accountRoutes/accountRoutes";
import { HomeRoutes } from "../homeRoutes/homeRoutes";
import WelcomePageView from "views/welcomePage/WelcomePageView";
import PublicationsDetails from "views/welcomePage/components/PublicationsGallery/PublicationsDetails";
import CourseDetails from "views/welcomePage/components/PublicationsGallery/CourseDetails";

export const AppRoutes: RouteItemConfig[] = [
  {
    path: "/account",
    name: "Account",
    component: AccountLayout,
    layout: "",
    default: false,
    authorize: false,
    roles: [],
    showInMenu: false,
    isRoute: true,
    subMenu: [...AccountRoutes],
  },
  {
    path: "/home",
    name: "Home",
    component: HomeLayout,
    layout: "",
    default: false,
    authorize: true,
    roles: [],
    showInMenu: false,
    isRoute: true,
    subMenu: [...HomeRoutes],
  },
  {
    path: "/",
    name: "WelcomePage",
    component: WelcomePageView,
    layout: "",
    default: true,
    authorize: false,
    roles: [],
    showInMenu: false,
    isRoute: true,
  },
  {
    path: "/PublicationsDetails/:id",
    name: "PublicationsDetails",
    component: PublicationsDetails,
    layout: "/",
    default: false,
    authorize: false,
    roles: [],
    showInMenu: false,
    isRoute: true,
  },
  {
    path: "/course/:id",
    name: "",
    component: CourseDetails,
    icon: "",
    layout: "/",
    default: true,
    isExact: true,
    authorize: false,
    roles: [],
    showInMenu: false,
    isRoute: true,
    id: 1,
    groupName: "essentials",
  },
];
